import { fetch } from '@/common/js/fetch';
import { serverCourseUrl, serverYreadUrl } from "./api";
import parseParams from '@/common/js/util';
import { DEFAULT_COMPETITION_TYPE } from '@/common/constant/qz';

/**
 * 获取课程详情&播放进度&列表
 * @param {number} libraryId
 * @returns
 */
export function getCourseDetail(libraryId) {
  // return Promise.resolve({
  //   "code": 200,
  //   "message": null,
  //   "body": {
  //     "baseInfo": {
  //       "id": 15170225,
  //       "layoutType": 8,
  //       "title": "探秘世界地理之最",
  //       "subTitle": null,
  //       "intro": "身临其境饱览世界地理！",
  //       "coverImageRes": "https://ydschool-online.nosdn.127.net/512e9c53-4e69-47a7-9544-d38ce736adeb.png",
  //       "squareCoverImageRes": null,
  //       "libraryCategory": 3,
  //       "libraryInnerCategory": 4,
  //       "libraryPlayType": 1,
  //       "author": "看鉴教育",
  //       "translator": null,
  //       "copyrightValidated": 1,
  //       "copyrightExpireDisplayStatus": null,
  //       "copyrightArea": "MAINLAND_CHINA",
  //       "supportTTS": 0,
  //       "hasCatalogue": 1,
  //       "sourceLibrary": "OWN",
  //       "creatorInfo": null,
  //       "rankingInfo": null,
  //       "originalPrice": "99",
  //       "bookNum": 51,
  //       "coreKnowledgePoints": [],
  //       "recommendTags": ["科普百科", "地理人文"],
  //       "needRecord": 0,
  //       "languageType": "CHINESE",
  //       "resourceType": null,
  //       "keywords": [],
  //       "recommendKeyword": "VIP"
  //     },
  //     "userPreference": {
  //       "canRead": 1,
  //       "like": 0,
  //       "collect": 0,
  //       "wantRead": 0,
  //       "buy": 0,
  //       "hasRead": 1,
  //       "readProgress": {
  //         "chapterId": "bk_5fc354fd7421492d8a52d7a9a419a4d5",
  //         "percent": 0.00,
  //         "fragment": 374,
  //         "chapterFragment": 0,
  //         "updateTime": 1723195454000
  //       }
  //     },
  //     "catalogue": {
  //       "totalChapterCount": 51,
  //       "updateChapterCount": 51,
  //       "freeChapterCount": 1,
  //       "chapters": [
  //         {
  //           "bookId": "bk_5fc354fd7421492d8a52d7a9a419a4d5",
  //           "chapterId": "bc_6f863b41e3764672b0711ad6898a6284",
  //           "vcloudObjectVid": 8863884805,
  //           "vcloudObjectName": "03c475e627104971b174309f61ad2fc4.mp4",
  //           "canRead": 1,
  //           "seqIndex": 1,
  //           "contentResourceKey": null,
  //           "profileUrl": null,
  //           "modelType": null,
  //           "chapterBackgroundImg": "https://ydschool-online.nosdn.127.net/babb33c438944d938682aa8a099df5bc.png",
  //           "title": "1.世界地理之最宣传片",
  //           "hasManuscript": null,
  //           "hasBackgroundImg": false,
  //           "backgroundImgs": null,
  //           "fragment": 228,
  //           "currentFragment": 0,
  //           "latestReadChapter": 1,
  //           "readFragment": 0,
  //           "preview": null,
  //           "readNum": 0,
  //           "updateTime": 1705989142000,
  //           "subChapters": null,
  //           "hide": null,
  //           "nonText": null,
  //           "originalId": null
  //         }, {
  //           "bookId": "bk_5fc354fd7421492d8a52d7a9a419a4d5",
  //           "chapterId": "bc_215c008637d4476c9e1fc90ffcc64888",
  //           "vcloudObjectVid": 8863896580,
  //           "vcloudObjectName": "058662eeae1a44178228e126bcdec6e8.mp4",
  //           "canRead": 1,
  //           "seqIndex": 2,
  //           "contentResourceKey": null,
  //           "profileUrl": null,
  //           "modelType": null,
  //           "chapterBackgroundImg": "https://ydschool-online.nosdn.127.net/294350ed9eed4d45b93917bb6e1677bd.png",
  //           "title": "2.国土面积最大的国家——俄罗斯",
  //           "hasManuscript": null,
  //           "hasBackgroundImg": false,
  //           "backgroundImgs": null,
  //           "fragment": 377,
  //           "currentFragment": 373,
  //           "latestReadChapter": null,
  //           "readFragment": null,
  //           "preview": null,
  //           "readNum": 0,
  //           "updateTime": 1705989143000,
  //           "subChapters": null,
  //           "hide": null,
  //           "nonText": null,
  //           "originalId": null
  //         }, {
  //           "bookId": "bk_5fc354fd7421492d8a52d7a9a419a4d5",
  //           "chapterId": "bc_78f2ba8aff9343479c5198936cb8df86",
  //           "vcloudObjectVid": 8863870273,
  //           "vcloudObjectName": "1f98e0fdb7ac4d3281c23705c0083c9a.mp4",
  //           "canRead": 1,
  //           "seqIndex": 3,
  //           "contentResourceKey": null,
  //           "profileUrl": null,
  //           "modelType": null,
  //           "chapterBackgroundImg": "https://ydschool-online.nosdn.127.net/1ed2ea4ab2c2417fad8bbfe6bc7c19b4.png",
  //           "title": "3.国土面积最小的国家——梵蒂冈",
  //           "hasManuscript": null,
  //           "hasBackgroundImg": false,
  //           "backgroundImgs": null,
  //           "fragment": 338,
  //           "currentFragment": 605,
  //           "latestReadChapter": null,
  //           "readFragment": 330,
  //           "preview": null,
  //           "readNum": 0,
  //           "updateTime": 1705989143000,
  //           "subChapters": null,
  //           "hide": null,
  //           "nonText": null,
  //           "originalId": null
  //         }
  //       ]
  //     }
  //   },
  //   "msg": null
  // })
  return fetch(`${serverYreadUrl}v2/library/getInfo?libraryId=${libraryId}`, {},{
    headers: {
      'x-youdao-athena-competition-type': 'MATHS_TALENTS'
    }
  })
}

/**
 *  获取课程视频播放地址
 * @param {string} objectName
 * @param {number} vid
 * @returns {Promise<{
 *  code: number,
 *  body: {
 *    videoUrl: string,
 *  }
 * }>}
 */
export function getCourseVideo(objectName, vid) {
  // return Promise.resolve({
  //   "code": 200,
  //   "message": null,
  //   "body": {
  //     "videoUrl": "https://jdvodr9wqroxs.vod.126.net/jdvodr9wqroxs/03c475e627104971b174309f61ad2fc4.mp4?wsSecret=5cc65f757fa2b34e17d3d6f3e5443707&wsTime=1764224702",
  //     "videoCoverImageUrl": null
  //   },
  //   "msg": null
  // })
  return fetch(`${serverYreadUrl}v1/resource/netease/vcloud/video`, {
    objectName,
    vid,
  })
}

/**
 * 更新视频学习进度
 * @param {Object} params
 * @param {string} params.bookId
 * @param {string} params.chapterId
 * @param {Number} params.booklibraryId
 * @param {Number} params.fragment 表示从0开始的进度
 * @param {Number} params.interval 表示从上次进度到这次上报进度之间的差
 * @returns
 */
export function updateCourseProgress(params) {
  return fetch(`${serverYreadUrl}my/read/online/punch`, {
    ...parseParams(params)
  }, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
/**
 * @deprecated 视频目前只有课程维度记录，先不展示列表了
 *
 * */
export function getStudyRecord(params) {
  return Promise.resolve({
    "code": 200,
    "message": null,
    "body": {
      "readOnlineList": []
    }
  })
  return fetch(`${serverCourseUrl}v3/my/read/online`,{
    competitionType: DEFAULT_COMPETITION_TYPE,
    ...parseParams(params),
  })
}

/**
 * 获取课程列表
 * */
export function getContentList(competitionType=DEFAULT_COMPETITION_TYPE) {
  // return Promise.resolve({
  //   code: 200,
  //   body: {
  //     "contents":[
  //       {
  //         bookLibraryId: 1,
  //         cornerImgUrl:'',
  //         title: '组合数学',
  //         teacher: '马杰',
  //         cardImgUrl:'https://ydschool-online.nosdn.127.net/178231d3-cd3a-4d25-b5f8-c9decf1690fc.png',
  //       },
  //       {
  //         bookLibraryId: 2,
  //         cornerImgUrl:'',
  //         title: '线性代数',
  //         teacher: '余成龙',
  //         cardImgUrl:'https://ydschool-online.nosdn.127.net/ccf59ab9-2d8f-4db9-a7ac-e8cf0b86fd7c.png',
  //       },
  //       {
  //         cornerImgUrl:'',
  //         bookLibraryId: 3,
  //         title: '初等代数',
  //         teacher: '莫仲鹏',
  //         cardImgUrl:'https://ydschool-online.nosdn.127.net/2eb6bd37-a271-4f47-a183-8c62f1ef5fd7.png',
  //       },
  //       {
  //         bookLibraryId: 4,
  //         cornerImgUrl:'',
  //         title: '微积分',
  //         teacher: '李逸',
  //         cardImgUrl:'https://ydschool-online.nosdn.127.net/5a49cb9f-7625-4769-8a16-659edb482154.png',
  //       }
  //     ]
  //   }
  // })
  return fetch(`${serverCourseUrl}v1/user/competition/customized/study/content/list?competitionType=${competitionType}`)
}